import React from "react";

const SuccessModal = ({
  show,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.6)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            {/* <button className="btn-close" onClick={onCancel}></button> */}
          </div>

          <div className="modal-body">
            <p>{message}</p>
          </div>

          <div className="modal-footer">
            <button className="default-btn" onClick={onCancel}>
              {cancelText}
            </button>
            <button className="theme-btn" onClick={onConfirm}>
              {confirmText}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
